import {
  AllocationDestination,
  RealizedAllocationAmountState,
} from '@cash-web/protos/squareup/cash/paychecks/common.pb'

export type DistributionType = {
  id: string
  flagZeroValues?: boolean
  label: string
  color: string
  note?: string
  percentage: number
  state?: RealizedAllocationAmountState
  value: number | string
  action?: () => void
  variant: 'actionable' | 'locked' | 'default'
}

export const DISTRIBUTION_IDS: (keyof AllocationDestination)[] = ['cashBalance', 'investing', 'savings', 'bitcoin']

export const getDestinationId = (allocationDestination: AllocationDestination) => {
  return DISTRIBUTION_IDS.find(type => allocationDestination?.[type] !== undefined)
}
